export default __webpack_public_path__ + "static/media/Anchor.2151d243.svg";